







































import * as BookGoodsBlocks from './blocks'
import {
  BookGoodsModel,
  bookGoodsModelProvider,
  getBookGoodsModel,
} from './model'
import { defineClassComponent, useQuery } from '@/hooks'
import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookGoodsBlocks,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '套餐详情',
        }))

        // 提供标销数据
        bookGoodsModelProvider.provide(this.bookGoodsModel as any)

        onMounted(async () => {
          // 获取标销商品数据
          this.bookGoodsModel.value = (await getBookGoodsModel(
            this.query.goodsId,
            this.query.parentCommodityId,
            this.query.skuId,
            this.query.type === 'exchange',
            this.query.previewStatus,
          )) as any
          this.loading.value = false

          Track.pushEvent({
            type: 'load',
            name: '浏览商品详情页',
            id: 'LiuLanShangPinXiangQing',
            extra: {
              commodity_source: Track.getFrom(),
              commodity_id: this.bookGoodsModel.value.commodityId,
              commodity_name: this.bookGoodsModel.value.commodityTitle,
              commodity_tag: '',
              original_price: this.bookGoodsModel.value.dashPrice,
              present_price: this.bookGoodsModel.value.lowestPrice,
              discount_price:
                this.bookGoodsModel.value.dashPrice -
                this.bookGoodsModel.value.lowestPrice,
              store_id: this.bookGoodsModel.value.merchantId,
              store_name: this.bookGoodsModel.value.merchantName,
            },
          })

          onBeforeUnmount(() => {
            // 释放商品数据
            this.bookGoodsModel.value.$destroy?.()
          })
        })
      }

      query = useQuery<{
        goodsId: string
        parentCommodityId: string
        skuId: string
        type: string
        previewStatus: any
      }>()

      // 是否加载中
      loading = ref(true)

      // 标销商品数据
      bookGoodsModel = ref<BookGoodsModel>({} as any)
    },
)
